/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: directory-search-view-component.ts
 *
 * Created by kyang on 2020-09-11.
 */

function DirectorySearchViewController(
    this: JS5Object,
    $location: JS5Object,
    $q: JS5Object,
    $routeParams: JS5Object,
    BreadcrumbService: JS5Object,
    DirectoryService: JS5Object,
    FileSystemService: JS5Object,
    FileSystemEditService: JS5Object,
    ModalService: JS5Object,
    NavbarUtilService: JS5Object,
    PermissionsService: JS5Object,
    SearchFilterService: JS5Object,
    uiGridConstants: JS5Object,
) {

    //======//
    // Grid //
    //======//

    const columnDefs = [
        {
            field: 'name',
            displayName: 'Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'description',
            displayName: 'Description',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'path',
            displayName: 'Path',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'defaultPermissionRead',
            type: 'boolean',
            maxWidth: 95,
            displayName: 'Read',
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        }, {
            field: 'defaultPermissionWrite',
            type: 'boolean',
            maxWidth: 95,
            displayName: 'Write',
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        }
    ];

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefs,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };

    this.onRowDblClick = (row: JS5Object) => {
        navigateToEditView(row.entity);
    };

    //======//
    // Data //
    //======//

    const setBreadcrumbData = (fileSystem: JS5Object) => {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb({
            location: '/system/fileSystems/search',
            name: 'File Systems',
            params: angular.copy($location.search())
        });
        FileSystemEditService.setOriginalEditData(fileSystem);
    };

    const getData = () => {
        let criteria = {
            fetchOffset: 0,
            fetchLimit: 1000000,
            searchString: $location.search().searchText
        };

        this.loadingIndicator.show = true;
        $q.all([
            DirectoryService.getDirectories(criteria)
                .then((directories: JS5Object) => {
                    this.gridOptions.data = _.filter(directories, {
                        filesystemId: $routeParams.id
                    });
                }),
            FileSystemService.getFileSystem($routeParams.id)
                .then(setBreadcrumbData)
        ]).finally(() => {
            this.loadingIndicator.show = false;
        })
    };


    //=========//
    // Toolbar //
    //=========//

    const navigateToEditView = (entity: JS5Object) => {
        let fileSystemId = $routeParams.id;
        let directoryId = _.get(entity, 'id') || this.gridApi.selection.getSelectedRows()[0].id;
        $location.url(`/system/fileSystems/edit/${fileSystemId}/directories/edit/${directoryId}`);
    };

    const openMoveFolderModal = () => {
        let sourceFileSystemId = $routeParams.id;
        let directory = this.gridApi.selection.getSelectedRows()[0];
        ModalService.showMoveDirectoryModal(sourceFileSystemId, (targetFileSystem: JS5Object) => {
            this.loadingIndicator.show = true;
            DirectoryService.moveDirectory(directory, targetFileSystem.id)
                .then(getData);
        });
    };

    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: () => true,
            onClick: () => {
                navigateToEditView({id: -1});
            }
        }, {
            label: 'Edit',
            enabled: () => {
                return !_.isEmpty(this.gridApi.selection.getSelectedRows());
            },
            onClick: navigateToEditView
        }, {
            label: 'Move',
            icon: ['fa-folder-o', 'fa-arrow-right'],
            enabled: () => {
                return !_.isEmpty(this.gridApi.selection.getSelectedRows());
            },
            onClick: openMoveFolderModal
        }
    ];


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (!PermissionsService.isAdmin()) {
            $location.url('/login');
        } else {
            NavbarUtilService.viewSearchFunction = getData;
            SearchFilterService.populateCriteriaFromLocationSearch();
            getData();
        }
    };
}

angular.module('prism-ui.fileSystem').component('directorySearchView', {
    templateUrl: 'system/fileSystem/editView/directory/searchView/directory-search-view-template.html',
    controller: DirectorySearchViewController
});
